<template>
  <WalkthroughTour />
  <RouterView :key="route.fullPath" />
</template>

<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router';
import WalkthroughTour from './components/global/WalkthroughTour.vue';
const route = useRoute();
</script>
